module.exports = __webpack_public_path__ + "files/69dcd57096a0416fec6d629ec01354e3.png";